define('app/views/discount_coupon_view',['app/setup'], function(takhfifan) {

  takhfifan.DiscountCouponView = Backbone.View.extend({

    events: {
      'click .tkh-apply-discount' : 'apply',
      'click .tkh-remove-discount' : 'apply',
      'change #discount-coupon-input' : 'showDiscountCouponInput',
      'keyup #coupon_code' : 'disableButton',
      'change #coupon_code' : 'disableButton'
    },
    initialize: function() {
      var discountInputWrapper = this.$('.discount-input');
      if(this.$el.data('discount-coupon') == 'has-discount-coupon'){
        this.$('#discount-coupon-input').prop('checked', true);
        discountInputWrapper.show();
      }
      this.$submitBtn = this.$('.tkh-apply-discount');
    },
    apply: function(event) {
      this.$submitBtn.prop('disabled',true).empty().append('<div class="btn-text"><span class="spinner"></span></div>');
      this.$('#discount-coupon-form').submit();
    },
    showDiscountCouponInput: function(evt) {
      var discountInputWrapper = this.$('.discount-input');
      if($(evt.target).is(':checked')){
        discountInputWrapper.show();
      }
      else{
        discountInputWrapper.hide();
        if(this.$el.data('discount-coupon') == 'has-discount-coupon'){
          this.apply();
        }
        //this.$('#coupon_code').val('');
        //this.$('.tkh-apply-discount').prop('disabled', true);
      }
    },
    disableButton: function(evt) {
      if($(evt.target).val() == ''){
        this.$submitBtn.prop('disabled', true);
      }
      else{
        this.$submitBtn.prop('disabled', false);
      }
    }
  });

  $('.tkh-discount-coupon').each(function(){
    var $this = $(this);
    new takhfifan.DiscountCouponView({
      el: $this
    });
  });

});

